import React from 'react'

interface Props {
  readonly tag: string
  readonly title?: string
  readonly text?: string
  readonly author?: string
  readonly logo?: string
}

const DocsQuote: React.FunctionComponent<Props> = ({ tag, title, text, author, logo }) => {
  const Tag = `${tag}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  return (
    <div className='docs-quote'>
      {title && <Tag className='docs-quote-title'>{title}</Tag>}
      <div className='docs-quote-box'>
        <div className='docs-quote-text-wrapper'>
          <blockquote className='docs-quote-text'>
            <p>{text}</p>
            <footer>
              {author}
              <img className='docs-quote-logo' src={logo} alt={author} loading='lazy' />
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  )
}

export default DocsQuote
